import { CSSProperties } from 'react';
import { PageIssues } from '../../../shared/types/pageIssues.ts';

interface Props {
    style?: CSSProperties;
    pageIssues: PageIssues | undefined;
}

export function PageIssuesTable({
    style,
    pageIssues,
}: Props) {
    const nightTasksCount = pageIssues ? pageIssues.nightTasks : 0;
    const hasNightTasks = nightTasksCount > 0;

    return (
        <table style={Object.assign({ border: '4px solid #04aa6d' }, style)}>
            <tbody>
                <tr>
                    <th className='tasks--medium-text' style={{ width: '60%', fontSize: '28px', paddingTop: '2px', paddingBottom: '2px', paddingLeft: '16px' }}>
                        Night tasks
                    </th>
                    <td
                        className='tasks--large-text'
                        style={{
                            width: '40%',
                            paddingTop: '2px',
                            paddingBottom: '2px',
                            paddingRight: '8px',
                            backgroundColor: hasNightTasks ? '#c6cff8' : '#04aa6d',
                            color: hasNightTasks ? undefined : 'white',
                        }}
                    >
                        {pageIssues ? pageIssues.nightTasks : ''}
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
